// extracted by mini-css-extract-plugin
export default {"legacy-dropdown":"styles__legacy-dropdown____bXsr","options":"styles__options___rwSgg","option":"styles__option___R6WHP","toggle":"styles__toggle___UoTUP"};